import React from 'react';
import './MenuHighlights.css';
import { Link } from 'react-router-dom';

const categories = [
    { title: 'Pizza', image: 'https://images.unsplash.com/photo-1574071318508-1cdbab80d002?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60' },
    { title: 'Calzones', image: 'https://images.unsplash.com/photo-1707080032705-ec2df78fd395?q=80&w=687&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D' },
    { title: 'Pasta', image: 'https://images.unsplash.com/photo-1563379926898-05f4575a45d8?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60' },
    { title: 'Burgers', image: 'https://images.unsplash.com/photo-1568901346375-23c9450c58cd?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60' },
    { title: 'Sandwiches', image: 'https://images.unsplash.com/photo-1528735602780-2552fd46c7af?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60' },
    { title: 'Salads', image: 'https://images.unsplash.com/photo-1512621776951-a57141f2eefd?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60' }
];

const MenuHighlights = () => {
    return (
        <div className="menu-highlights">
            <h2>Our Menu</h2>
            <div className="highlights-grid">
                {categories.map((item, index) => (
                    <Link to="/menu" key={index} className="highlight-card">
                        <div className="highlight-image" style={{ backgroundImage: `url(${item.image})` }}>
                            <div className="overlay">
                                <h3>{item.title}</h3>
                            </div>
                        </div>
                    </Link>
                ))}
            </div>
        </div>
    );
};

export default MenuHighlights;
